const getSystemsOptions = (systems) =>
  systems
    .map((system) => ({
      value: system.id,
      label: system.ciclo,
    }))
    .sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (b.label < a.label) {
        return 1;
      }
      return 0;
    });

export default getSystemsOptions;
